export default function isNumber(n) {
  return typeof n === 'number'
}